import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>1. Üldsätted</Summary>
        <Details>
          <Text>
            1.1. Käesolevad iseteeninduse kasutustingimused (edaspidi{" "}
            <strong>Tingimused</strong>) reguleerivad Fresh Finance OÜ
            iseteeninduskeskkonna (edaspidi <strong>Iseteenindus</strong>)
            kasutamist füüsiliste ja juriidiliste isikute poolt, kellel on või
            on olnud Fresh Finance OÜ (Fresh Finance OÜ, registrikood 12243370,
            aadress Tartu mnt 83, 10115, edaspidi <strong>Fresh Finance</strong>
            ) ees rahaline kohustus ja kes on kantud Iseteenindusega seotud
            Fresh Finance-i süsteemidesse (edaspidi <strong>Klient</strong>).
          </Text>
          <Text>
            1.2. Iseteenindus võimaldab Kliendil saada ülevaadet Fresh Finance-i
            nõuetega ja Kliendi kohustustega seonduvatest andmetest ja teha
            arvutivõrgu vahendusel Fresh Finance-i poolt võimaldatud toiminguid.
          </Text>
          <Text>
            1.3. Iseteenindust kasutades kinnitab Klient, et on Tingimustega
            tutvunud, nõustub Tingimustega ja kohustub neid järgima. Tingimused
            on Kliendile siduvad.
          </Text>
          <Text>
            1.4. Lisaks Tingimustele on Klient Iseteenindusse sisenedes ja seal
            toimingute tegemisel kohustatud järgima Fresh Finance-i poolt
            Iseteeninduses antud mistahes lisajuhiseid.
          </Text>
          <Text>
            1.5. Fresh Finance jätab endale õiguse ühepoolselt muuta
            Iseteeninduse funktsioone ja Iseteeninduse kaudu võimaldatavate
            teenuste ja toimingute mahtu ning nende kasutamise korda Klienti
            sellest teavitamata.
          </Text>
          <Text>
            1.6. Fresh Finance-il on õigus teha Iseteeninduses hooldustöid ning
            Fresh Finance teavitab planeeritud hooldustöödest või ette teada
            teenuse katkemisest Iseteeninduse või Fresh Finance-i veebilehe (
            <a
              href="https://punkfinance.ee/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.punkfinance.ee
            </a>
            ) kaudu.
          </Text>
          <Text>
            1.7. Fresh Finance-il on õigus Tingimusi igal ajal muuta, teavitades
            sellest Klienti Iseteeninduse või oma veebilehe (
            <a
              href="https://punkfinance.ee/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.punkfinance.ee
            </a>
            ) kaudu. Tingimuste muudatused jõustuvad muudatuste Iseteeninduses
            või veebilehel avaldamise kuupäevast, kui muudetud Tingimustes ei
            ole sätestatud teisiti.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>2. Iseteenindusse sisenemine ja turvalisus</Summary>
        <Details>
          <Text>
            2.1. Iseteeninduse kasutamiseks tuleb Kliendil Iseteenindusse sisse
            logida kasutades selleks ettenähtud võimalusi.
          </Text>
          <Text>
            2.2. Kliendil on esmakordselt võimalik Iseteenindusse sisse logida
            ID-kaardiga, Mobiil-ID-ga või Smart-ID-ga.
          </Text>
          <Text>
            2.3. Pärast esmakordset sisselogimist on kliendil võimalus luua oma
            kasutajakonto ning sellisel juhul saab Klient hiljem Iseteenindusse
            sisse logida lisaks ka kasutajakonto kaudu, sisestades
            sisselogimisel kasutajanime ja parooli.
          </Text>
          <Text>
            2.4. Kliendi valitud Iseteeninduse parool on konfidentsiaalne teave,
            mida Klient kohustub hoidma saladuses ning mitte avalikustama
            kolmandatele isikutele.
          </Text>
          <Text>
            2.5. Iseteeninduse kasutamiseks vajaliku ja sobiva tark- ja
            riistvara olemasolu peab Klient tagama ise. Klient on kohustatud
            tagama, et tema turva- ja muud lahendused (sh viirusetõrje programm)
            vastavad kaasaegsetele standarditele ja ei blokeeri Iseteeninduse
            kasutamist.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>3. Kliendi õigused, kohustused ja vastutus</Summary>
        <Details>
          <Text>3.1. Klient kohustub:</Text>
          <Text>
            3.1.1. hoidma turvaliselt ja vältima Iseteeninduse parooli,
            ID-kaardi PIN- ja PUK-koodide, Mobiil-ID PIN- ja PUK-koodide,
            Smart-ID PIN-koodide sattumist kolmandate isikute valdusse ning
            mitte andma oma ID-kaarti kolmandate isikute kätte;
          </Text>
          <Text>
            3.1.2. hoidma turvaliselt ja mitte avalikustama kolmandatele
            isikutele mistahes muud Kliendiga või Fresh Finance-iga seotud
            konfidentsiaalset teavet, samuti vältima kolmandate isikute
            juurdepääsu nimetatud teabele;
          </Text>
          <Text>
            3.1.3. viivitamatult teavitama Fresh Finance-i Iseteeninduse
            parooli, ID-kaardi PIN- või PUK-koodide, Mobiil-ID PIN- või
            PUK-koodide, Smart-ID PIN-koodide kolmandatele isikutele teatavaks
            saamisest ning mistahes muust asjaolust, mis võib tingida
            Iseteeninduse väärkasutamise Kliendi nimel;
          </Text>
          <Text>
            3.1.4. tagama, et kolmandatel isikutel ei oleks juurdepääsu Kliendi
            poolt Fresh Finance-ile avaldatud e-posti aadressi(de)le, millega on
            seotud Kliendi kasutajakonto;
          </Text>
          <Text>
            3.1.5. hoidma oma Iseteeninduses kuvatavad andmed ajakohased ja
            korrektsed ning kontaktandmete muutumisel tegema 10 (kümne) päeva
            jooksul vastavad muudatused Iseteeninduses toodud Kliendi andmetes.
          </Text>
          <Text>
            3.2. Klient vastutab Iseteeninduse kaudu võetud kõigi kohustuste ja
            tehtud toimingute eest, samuti Kliendi sisestatud andmete õigsuse
            eest.
          </Text>
          <Text>
            3.3. Klient on teadlik ja kinnitab, et Iseteeninduse kaudu esitatud
            Kliendi tahteavaldused, dokumendid ja tehtud toimingud on
            õiguslikult siduvad, omavad omakäeliselt allkirjastatud
            dokumentidega võrdset õiguslikku jõudu ning Klient vastutab kõigi
            tekkinud Kliendi kohustuste eest. Fresh Finance-il on õigus nõuda
            Iseteeninduse kaudu esitatavate dokumentide digitaalset
            allkirjastamist.
          </Text>
          <Text>
            3.4. Klient võib igal ajal Iseteeninduse kasutamisest loobuda,
            teavitades Fresh Finance-i vastavast soovist Fresh Finance-i
            veebilehel{" "}
            <a
              href="https://punkfinance.ee/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.punkfinance.ee
            </a>{" "}
            toodud kontaktandmeid kasutades. Sellele järgneb Fresh Finance-i
            Kliendi ligipääsu Iseteenindusele blokeerimine.
          </Text>
          <Text>
            3.5. Kui Klient soovib esitada küsimusi või edastada tähelepanekuid
            Iseteeninduse kohta, saab seda teha võttes ühendust
            klienditeenindusega Fresh Finance-i veebilehe kuulje kaudu või
            saatma teate e-posti aadressile (
            <a
              href="mailto:info@punkfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              info@punkfinance.ee
            </a>
            ).
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>4. Fresh Finance-i õigused ja kohustused</Summary>
        <Details>
          <Text>
            4.1. Fresh Finance-il on õigus takistada või piirata juurdepääsu
            Iseteenindusele või jätta Iseteeninduses tehtud toimingud
            aktsepteerimata, juhul kui:
          </Text>
          <Text>
            4.1.1. Kliendi Iseteeninduse parooli sisestatakse vähemalt kolm
            korda valesti;
          </Text>
          <Text>
            4.1.2. Fresh Finance-ile on teatavaks saanud asjaolu, mille alusel
            võib järeldada, et Iseteeninduses Kliendi toimingu tegemiseks
            vajalikud vahendid on teatavaks saanud kolmandale isikule; või
          </Text>
          <Text>
            4.1.3. Fresh Finance on tuvastanud Iseteenindusse sisenemiseks või
            Iseteeninduses toimingute teostamiseks kasutatud arvuti osas
            Iseteeninduse vastu suunatud tegevuse;
          </Text>
          <Text>
            4.1.4. Fresh Finance on tuvastanud Iseteeninduse kasutamise viisil,
            mis on vastuolus kehtivate õigusaktidega; või
          </Text>
          <Text>4.1.5. Klient on rikkunud Tingimusi; või</Text>
          <Text>
            4.1.6. Klient on rikkunud Fresh Finance-iga sõlmitud kokkuleppest
            või lepingust tulenevaid kohustusi ning ei ole nimetatud kohustusi
            täitnud Fresh Finance-i poolt antud täiendava tähtaja jooksul.
          </Text>
          <Text>
            4.2. Fresh Finance-il on õigus igal ajal Iseteeninduse teenuse
            pakkumine ajutiselt või lõplikult lõpetada, teavitades sellest
            Klienti.
          </Text>
          <Text>
            4.3. Kui Fresh Finance-il tekib kahtlus Kliendi poolt Iseteeninduse
            kaudu esitatud dokumentide või andmete ehtsuse või õigsuse kohta, on
            Fresh Finance-il õigus nõuda Kliendilt täiendavate dokumentide või
            andmete esitamist ja Kliendil kohustus need esitada.
          </Text>
          <Text>
            4.4. Fresh Finance ei vastuta Kliendile tekitatud kahju eest, kui
            kolmas isik siseneb Kliendi andmeid, paroole ja/või PIN–koode
            kasutades Iseteenindusportaali ja teeb Kliendi nimel toiminguid.
          </Text>
          <Text>
            4.5. Fresh Finance ei vastuta rikete ja häirete eest Iseteeninduse
            töös, mille on põhjustanud Kliendi seadmed, Kliendi e-posti
            konfiguratsioon või ülekoormatus või Kliendi arvuti mittevastavus
            Iseteeninduse kasutamiseks vajalike infotehnoloogiliste nõuetega.
          </Text>
          <Text>
            4.6. Fresh Finance ei vastuta mistahes tehniliste rikete või
            häiretega seoses Iseteeninduse kasutamise võimatuse tõttu Kliendile
            tekkinud kahju eest.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>5. Intellektuaalse omandi kaitse</Summary>
        <Details>
          <Text>
            5.1. Iseteeninduse keskkond on Fresh Finance-i omand, keskkonna sisu
            (sh graafika, tekst, logod, ikoonid, pildid) ja tarkvara
            autoriõigused kuuluvad Fresh Finance-ile ning on kaitstud
            intellektuaalse omandi kaitset reguleerivate õigusaktidega.
          </Text>
          <Text>
            5.2. Iseteeninduse keskkonna vorme, sisu ja andmeid ei ole lubatud
            kopeerida, paljundada, edasi anda, müüa või mistahes muul viisil
            kasutada mitte-eesmärgipärasel viisil (sh kommertslikel
            eesmärkidel). Iseteeninduse kopeerimine, levitamine, edastamine,
            avalikustamine või muutmine ei ole lubatud ja toob kaasa vastutuse
            kooskõlas autoriõiguse seaduse ja teiste intellektuaalse omandi
            kaitset reguleerivate õigusaktidega.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>6. Isikuandmete töötlemine</Summary>
        <Details>
          <Text>
            6.1. Fresh Finance töötleb Iseteenindusega seoses Kliendi
            isikuandmeid, mis on juba Fresh Finance-i süsteemides olemas ja
            isikuandmeid, mille Klient on Iseteenindusse sisestanud (sh Kliendi
            isiku tuvastamiseks Iseteenindusse sisselogimisel) või mis on Fresh
            Finance-ile Kliendiga suhtlemise käigus muul viisil teatavaks
            saanud. Fresh Finance töötleb Kliendi isikuandmeid vastavalt
            privaatsusteatele, mis on kättesaadav aadressil{" "}
            <a
              href="https://punkfinance.ee/privaatsusteade/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://punkfinance.ee/privaatsusteade/
            </a>
            .
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
